import React from 'react'
import styled from '../styles/Footer.module.scss'

/*---------------import/\---------------*/

const Footer:React.FC = () => {
  return (
    <div className={styled.footer}>
    </div>
  )
}

export default Footer